<template>
  <ServerDataTable
    ref="usuariosTable"
    :columns="columnas"
    :fetchData="consultarUsuarios"
    :extraParams="{}"
    rowKey="id"
    initialSortField="username"
    initialSortDirection="asc"
    titulo="Usuarios"
    :borrados="true"
  >
    <template #header-actions>
      <p @click="abrirAltaUsuario"><i class="fa fa-plus" aria-hidden="true"></i></p>
    </template>

    <template #acciones="{ row }">
      <div class="acciones-usuario">
        <a
          v-if="!row.deleted_at"
          href="#"
          class="cursor-pointer me-3"
          data-bs-toggle="tooltip"
          title="Editar Usuario"
          @click.prevent="abrirEditarUsuario(row)"
        >
          <i class="fas fa-user-edit text-analiza-dark"></i>
        </a>
        <a
          v-if="puedeMostrarBotonEliminar(row)"
          href="#"
          class="cursor-pointer"
          data-bs-toggle="tooltip"
          title="Eliminar Usuario"
          @click.prevent="mostrarConfirmacionBorrar(row.id)"
        >
          <i class="fas fa-trash text-analiza-dark"></i>
        </a>
      </div>
    </template>
  </ServerDataTable>

  <Modal @cerrar-modal="cerrarModal" :modalActive="modalActive">
    <div class="modal-content">
      <alta-usuario-form
        v-if="tipoModal == 'A'"
        :key="0"
        @cerrar-modal="onUsuarioGuardado"
      ></alta-usuario-form>
      <edita-usuario-form
        v-if="tipoModal == 'E'"
        :key="usuarioEditId"
        :usuarioId="usuarioEditId"
        :usuarioName="usuarioEditName"
        :usuarioUsername="usuarioEditUsername"
        :usuarioEmail="usuarioEditEmail"
        :usuarioRolId="usuarioEditRol"
        :usuarioOficinaId="usuarioEditOficina"
        :usuarioDepartamentoId="usuarioEditDepartamento"
        :puedeEditar="buscaPermiso('edit-usuarios')"
        @cerrar-modal="onUsuarioGuardado"
      ></edita-usuario-form>
      <cambio-clave-usuario-form
        v-if="tipoModal == 'C'"
        :key="usuarioEditId"
        :usuarioId="usuarioEditId"
        :usuarioUsername="usuarioEditUsername"
        :usuarioEmail="usuarioEditEmail"
        @cerrar-modal="cerrarModal"
      ></cambio-clave-usuario-form>
    </div>
  </Modal>

  <div v-if="confirmacionVisible" class="overlay">
    <div class="confirm-box">
      <p class="mt-4 mb-4">{{ mensajeConfirmacion }}</p>
      <table class="mt-4 mb-4">
        <tbody>
          <tr>
            <td width="50%"><button class="btn-cancela" @click="cancelacion">Cancelar</button></td>
            <td width="50%"><button class="btn-confirma" @click="confirmacion">Confirmar</button></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import showSwal from "@/mixins/showSwal.js";
import Modal from "./components/Modal.vue";
import AltaUsuarioForm from "./components/AltaUsuarioForm.vue";
import EditaUsuarioForm from "./components/EditaUsuarioForm.vue";
import CambioClaveUsuarioForm from "./components/CambioClaveUsuarioForm.vue";
import ServerDataTable from "@/views/components/ServerDataTable.vue";
import { globalFunctionsMixin } from "@/mixins/globalFunctions.js";

export default {
  name: "Usuarios",
  components: {
    ServerDataTable,
    Modal,
    AltaUsuarioForm,
    EditaUsuarioForm,
    CambioClaveUsuarioForm
  },
  mixins: [globalFunctionsMixin],
  data() {
    return {
      confirmacionVisible: false,
      usuarioId: 0,
      mensajeConfirmacion: "",
      tipoModal: "",
      usuarioEditId: 0,
      usuarioEditName: "",
      usuarioEditRol: 0,
      usuarioEditUsername: "",
      usuarioEditEmail: "",
      usuarioEditDepartamento: "",
      usuarioEditOficina: "",
      modalActive: false
    };
  },

  computed: {
    columnas() {
      return [
        { key: "username", label: "Usuario", sortable: true },
        { key: "nombre", label: "Nombre", sortable: true },
        { key: "email", label: "Email", sortable: true },
        { key: "rol_name", label: "Rol", sortable: true },
        { key: "departamento_name", label: "Departamento", sortable: true },
        { key: "oficina_name", label: "Oficina", sortable: true },
        { key: "created_at", label: "Creado", sortable: true, format: "date" },
        { key: "deleted_at", label: "Eliminado", sortable: true, format: "date", indicaBaja: true },
        { key: "acciones", label: "Acciones", sortable: false, slot: "acciones" }
      ];
    }
  },

  methods: {
    mostrarConfirmacionBorrar(id) {
      this.confirmacionVisible = true;
      this.usuarioId = id;
      this.mensajeConfirmacion = "¿Confirma que desea eliminar este usuario?";
    },
    confirmacion() {
      this.confirmacionVisible = false;
      this.borrarUsuario(this.usuarioId);
    },
    cancelacion() {
      this.confirmacionVisible = false;
    },
    async consultarUsuarios(params) {
      try {
        const response = await this.$store.dispatch("auth/usuarios", {
          textoBuscador: params.search,
          pagina: params.page,
          perPage: params.pageSize,
          sortField: params.sortField,
          sortDirection: params.sortDirection,
          mostrarBorrados: params.mostrarBorrados
        });

        const rows = Array.isArray(response?.rows) ? response.rows : [];

        return {
          rows,
          total: Number(response?.total ?? rows.length),
          page: Number(response?.page ?? params.page),
          pageSize: Number(response?.pageSize ?? response?.perPage ?? params.pageSize)
        };
      } catch (error) {
        showSwal.methods.showSwal({
          type: "error",
          message: "Se ha producido un error",
          width: 500
        });

        return {
          rows: [],
          total: 0,
          page: params.page,
          pageSize: params.pageSize
        };
      }
    },
    abrirAltaUsuario() {
      this.modalActive = true;
      this.tipoModal = "A";
      this.usuarioEditId = 0;
      this.usuarioEditName = "";
      this.usuarioEditUsername = "";
      this.usuarioEditEmail = "";
      this.usuarioEditRol = 0;
      this.usuarioEditOficina = "";
      this.usuarioEditDepartamento = "";
    },
    abrirEditarUsuario(row) {
      this.modalActive = true;
      this.tipoModal = "E";
      this.usuarioEditId = row.id;
      this.usuarioEditUsername = row.username;
      this.usuarioEditEmail = row.email;
      this.usuarioEditName = row.nombre;
      this.usuarioEditRol = row.rol_id;
      this.usuarioEditOficina = row.oficina_id;
      this.usuarioEditDepartamento = row.departamento_id;
    },
    puedeMostrarBotonEliminar(row) {
      return !(row.deleted_at && this.buscaPermiso("edit-usuarios"));
    },
    async borrarUsuario(usuarioId) {
      try {
        const resp = await this.$store.dispatch("auth/borraUsuario", { id: usuarioId });

        if (resp.res == "OK") {
          showSwal.methods.showSwal({
            type: "success",
            message: resp.mensaje,
            width: 600
          });
          this.refrescarTabla();
        } else {
          showSwal.methods.showSwal({
            type: "error",
            message: resp.mensaje,
            width: 500
          });
        }
      } catch (error) {
        showSwal.methods.showSwal({
          type: "error",
          message: "Se ha producido un error",
          width: 500
        });
      }
    },
    cerrarModal() {
      this.modalActive = false;
    },
    onUsuarioGuardado() {
      this.modalActive = false;
      this.refrescarTabla();
    },
    refrescarTabla() {
      this.$refs.usuariosTable?.refresh();
    },
    irInicio() {
      this.$router.push("/profile");
    }
  },

  async beforeMount() {
    this.$store.state.showSidenav = true;
  },
};
</script>

<style lang="scss" scoped>
.usuarios {
  background-color: rgba(0, 176, 234, 0.5);
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  .modal-content {
    display: flex;
    flex-direction: column;

    h1,
    p {
      margin-bottom: 16px;
    }

    h1 {
      font-size: 32px;
    }

    p {
      font-size: 18px;
    }
  }
}

.acciones-usuario {
  display: flex;
  align-items: center;
  min-width: 72px;
}
</style>
